import React, { Component } from 'react';
import { Link, Events, scrollSpy } from 'react-scroll';
import { withTranslation } from 'react-i18next';
import cn from 'classnames';
import styles from './styles.scss';
import { updateString } from 'utils';
import iconUpdate from 'assets/images/icons/update-arrows.svg';
import { getLotsType } from '../helper';


class Nav extends Component {

  componentDidMount() {
    Events.scrollEvent.register('begin', function (to, element) {
      console.log('begin', arguments);
    });

    Events.scrollEvent.register('end', function (to, element) {
      console.log('end', arguments);
    });

    scrollSpy.update();
  }

  componentWillUnmount() {
    Events.scrollEvent.remove('begin');
    Events.scrollEvent.remove('end');
  }

  render() {
    const { t } = this.props;
    const { update } = this.props.building.data;
    let updateTime;
    if (update) {
      if (updateString(update).indexOf('Сегодня') == 0) {
        updateTime = 'cегодня';
      } else {
        updateTime = updateString(update);
      }
    }

    return (
      <div className={styles.ObjectNav}>
        <div className={styles.ObjectNavInner}>
          <div className={styles.ObjectNavBtns}>
            <Link
              to="photo"
              className={cn(styles.ObjectNavBtn, styles.Active)}
              activeClass={styles.Active}
              offset={-80}
              duration={500}
              smooth={true}
            >
              {t('components.building.main.nav.photo')}
            </Link>
            <Link
              to="info"
              className={styles.ObjectNavBtn}
              activeClass={styles.Active}
              offset={-80}
              duration={500}
              smooth={true}
            >
              {t('components.building.main.nav.info')}
            </Link>
            {getLotsType() > 0 && <Link
              to="flats"
              className={styles.ObjectNavBtn}
              activeClass={styles.Active}
              offset={-80}
              duration={500}
              smooth={true}
            >
              {t('components.building.main.nav.flats')}
            </Link>}
          </div>
          <div
            className={styles.UpdatedTime}
            data-tip={t('components.building.main.nav.tip')}
            data-for="global"
          >
            <img alt="icon" src={iconUpdate} />
            <span>
              <span className={styles.Hide1180}>{t('components.building.main.nav.updated')}</span> {updateTime}
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(Nav);



// WEBPACK FOOTER //
// ./src/components/Building/Main/Nav/Nav.js